import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ObjectUtils } from 'src/app/@core/utils/object-utils';
import { Nationality } from 'src/app/models/nationality';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import { NationalityService } from 'src/app/services/nationality.service';
import { OnbaseService } from 'src/app/services/onbase.service';

@Component({
  selector: 'app-person-information-step',
  templateUrl: './person-information-step.component.html',
  styleUrls: ['./person-information-step.component.sass']
})
export class PersonInformationStepComponent implements OnInit {

  constructor(private nationalityService: NationalityService, private onbaseService: OnbaseService) { }

  nationalities: Array<Nationality> = [];
  @Input() personInformationForm: FormGroup = new FormGroup({
    names: new FormControl(""),
    lastNames: new FormControl(""),
    fiscalId: new FormControl(""),
    fiscalIdName: new FormControl(""),
    fiscalIdType: new FormControl(""),
    nationality: new FormControl(""),
    sex: new FormControl(""),
    birthDate: new FormControl("", Validators.required),
    age: new FormControl(""),
    civilStatus: new FormControl("", Validators.required),
    dependentsAmount: new FormControl("", [Validators.required, Validators.min(0)]),
    email: new FormControl("", Validators.email),
    vehicle: new FormControl("", Validators.required),
    ocupation: new FormControl("", Validators.required),
    academicTitle: new FormControl("", Validators.required)
  });
  @Input() onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();
  civilStatuses: Array<{ key: string, value: string }> = [];
  ocupations: Array<{ key: string, value: string }> = [];
  academicTitles: Array<{ key: string, value: string }> = [];
  @Input() readonly = false;
  @Input() isShortFormActiveForPlan = false;
  async ngOnInit(): Promise<void> {
    if (this.onbaseCatalogue.economicActivity.length == 0) {
      this.onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
    }
    this.nationalities = (await this.nationalityService.readNationalities().toPromise()).response.content;
    this.civilStatuses = ObjectUtils.objectToArray(this.onbaseCatalogue.maritalStatus);
    this.ocupations = ObjectUtils.objectToArray(this.onbaseCatalogue.occupation);
    this.academicTitles = ObjectUtils.objectToArray(this.onbaseCatalogue.academicTitle);
  }

}
